export const GraftingProgramApplicationTypes = {
    AGE: "A",
    INSEMINATION: "I",
    PARTURITION: "P",
    SEPARATION: "S",
    INSERTION: "IN"
};
